export default {
    GeometryType: {
        0: "Point",
        1: "Line",
        2: "Polygon"
    },

    Basemaps: {
        0: "OpenStreetMap Carto",
        1: "Esri World Imagery",
        2: "None"
    },

    MapOutputFormat: {
        0: "jpg",
        1: "png",
    },

    ExportFormats: {
        0: "JSON",
        1: "KML",
        2: "Shapefile",
        3: "CSV",
        4: "CAD",
        5: "EM31 CSV",
        6: "EM38 CSV"
    },
    
    UserRole: {
        0: "Collector",
        1: "Editor",
        2: "Viewer",
    },

    UserCapability: {
        1: "Organizational Unit Administrator",
        2: "User Administrator"
    },

    ProductType: {
        0: "None",
        1: "Utility Mapper",
        2: "Sensor Mapper",
        4: "Pole Mapper",
        8: "Surface Mapper"
    },

    SortDirection: {
        0: "asc",
        1: "desc"
    },

    ExportStatus: {
        0: "Pending",
        1: "Processing",
        2: "Complete",
        3: "Failed"
    },

    ExportStatusTextClass: {
        0: "text-muted",
        1: "text-primary",
        2: "text-success",
        3: "text-danger"
    },

    ExportTaskType: {
        0: "Project Data Export",
        1: "Map Package Export",
        2: "Telus Report",
        3: "Ontario Locate Report"
    },

    LocateReportUtilityType: {
        0: "None",
        1: "Clear",
        2: "Mark"
    },

    WorkflowConfigFieldTypes: {
        "Text": "Text",
        "DropDownList": "DropDown List",
        "Radio": "Radio"
    }
}